import * as React from 'react';
import './MobileView.css';
import { Button } from '@material-ui/core';
import GetAppIcon from '@material-ui/icons/GetApp';
import icon from '../assets/icon.png';

const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.kruiswoordraadsel.app';

function MobileView() {
    const downloadClicked = () => {
        window.open(PLAY_STORE_URL, '_blank', 'noopener');
    };

    return (
        <div className="Body">
            <img src={icon} alt="Kruiswoordpuzzel" style={{ width: 64, height: 64, borderRadius: 14 }} />

            <h3 style={{ textAlign: 'center' }}>Kruiswoordpuzzel</h3>
            <h5 style={{ textAlign: 'center' }}>
                Op zoek naar een leuke en nuttige manier om de tijd te doden? Dan ben je hier aan het juiste adres.
                <br />Nederlandse kruiswoordpuzzels met afbeeldingen.
                <br />Talloze gevarieerde puzzels en een dagelijkse uitdaging.
            </h5>

            <Button
                variant="contained"
                color="primary"
                endIcon={<GetAppIcon />}
                onClick={downloadClicked}>
                Download op Google Play
            </Button>

            <div className="Footer">
                <a href="/privacy-policy.html">Privacybeleid</a>
                <span>·</span>
                <a href="/terms.html">Voorwaarden</a>
                <span>·</span>
                <a href="/account_deletion.html">Account verwijderen</a>
            </div>
        </div>
    );
}

export default MobileView;
